import { FC } from 'react'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import RequestDemoContainer from '~/features/request-demo'
import en_lp from '../../public/locales/en/landing-page.json'
import en_request_demo from '../../public/locales/en/request-demo.json'
import vn_lp from '../../public/locales/vi/landing-page.json'
import jp_lp from '../../public/locales/ja/landing-page.json'
import vn_request_demo from '../../public/locales/vi/request-demo.json'
import jp_request_demo from '../../public/locales/ja/request-demo.json'

const RequestDemoPage: FC = () => {
  return (
    <>
      <HeadMetaTags
        title={'Hireforce | Book a demo'}
        description="Hi new customer, book a demo and discover how Hireforce can provide the perfect solution."
      />
      <RequestDemoContainer />
    </>
  )
}

export default withTranslateProvider(RequestDemoPage, {
  en: { lp: en_lp, request_demo: en_request_demo },
  vi: { lp: vn_lp, request_demo: vn_request_demo },
  ja: { lp: jp_lp, request_demo: jp_request_demo }
})
